import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { type CountryCode, type ProjectCode } from '@constants'
import { useFastpassMerchantGoogleAnalyticEvent } from '@dni-analysis'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { WP_ORDER_TYPE } from '@hooks-api/types/dataModel/eCommerceOrders'
import { Box } from '@pets-ui/Box/Box'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { LayoutMyAccount } from '@wp-my-account/components/LayoutMyAccount'
import { WpOrder } from '@wp-my-account/WpOrder'
import { TheCampaignHeader } from '../../../components/TheCampaignHeader'
import { useFastpassMenuItems } from '../../../hooks/use-fastpass-menu-items'

const styles = stylex.create({
  root: {
    backgroundColor: colors.grey100,
    minHeight: '100vh',
  },
})

interface MerchantOrderListProps {
  projectCode: ProjectCode
  countryCode: CountryCode
  campaignId: number
  siteId: number
}

export function CampaignOrderList({ projectCode, siteId, countryCode, campaignId }: MerchantOrderListProps) {
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: member } = useApiCampaignMember({ code: campaignCodeFromUrl })
  const menuItem = useFastpassMenuItems('campaign', campaignCodeFromUrl, member?.user_name)
  const { sendCancelOrderEvent, sendBeginRepayEvent } = useFastpassMerchantGoogleAnalyticEvent({ projectCode, countryCode, campaignId })
  return (
    <Box rootStyle={styles.root}>
      <TheCampaignHeader projectCode={projectCode} countryCode={countryCode} campaignId={campaignId} />
      <LayoutMyAccount menuItem={menuItem}>
        <WpOrder
          environment="campaign"
          type={WP_ORDER_TYPE.CAMPAIGN}
          campaignId={campaignId}
          siteId={siteId}
          projectCode={projectCode}
          onRepayClick={sendBeginRepayEvent}
          onCancelOrderClick={sendCancelOrderEvent}
        />
      </LayoutMyAccount>
    </Box>
  )
}
